import { render, staticRenderFns } from "./CollaborateursChart.vue?vue&type=template&id=f1fd7318&"
import script from "./CollaborateursChart.vue?vue&type=script&lang=js&"
export * from "./CollaborateursChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports